/**
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-16 10:32:00
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-03-16 10:38:55
 * @FilePath: \hzs-nutra-wecom-shop\src\utils\api\workbench.js
 * @Description: 工作台
 */

import req from "@/utils/axios.js";
export default {
    // 客户生日列表
    _getStatistics(params) {
        return req.get("/wxShop/mySummaryData", {
            ...params
        })
    }
}